import { render, staticRenderFns } from "./ForgotPasswordValidate.vue?vue&type=template&id=16b67a5e&"
import script from "./ForgotPasswordValidate.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordValidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports